/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit DentalMonitoring/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import Content from './Content/index'
import Empty from './Empty/index'
import EnsureUrl from 'DesignSystem/EnsureUrl/react'
import Error from './Error/index'
import Loading from './Loading/index'
import No from './No/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function DentalMonitoring({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/DentalMonitoring"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let tabPatientIdValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'patient_id',
})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<EnsureUrl
  viewPath={`${viewPath}/EnsureUrl`}
 data="tab.patient_id"
 patientId={tabPatientIdValueData}
 patientTab="dental-monitoring"
/>
<div
  data-testid="DentalMonitoring.Vertical"
  data-view-path={viewPath}
 style={{'--ml-1-BxtSt': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--mr-2-BxtSt': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical}`}
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Loading'}>
<Loading
  viewPath={`${viewPath}/Loading`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Empty'}>
<Empty
  viewPath={`${viewPath}/Empty`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Error'}>
<Error
  viewPath={`${viewPath}/Error`}
/>
</fromFlow.When>
</div>
{children}
</React.Fragment>)
}